import { createContext } from 'react'
import { ToastType } from '../model/types'

interface ToastContextType {
  addToast: (title: string, description?: string, variant?: ToastType) => void
}

export const ToastContext = createContext<ToastContextType | undefined>(undefined)
